import React, { FC, useEffect, useState } from "react";
import { Container, Row, Col} from "reactstrap";
import List from "devextreme-react/list";
import SelectBox from 'devextreme-react/select-box';
import { IUserHelp } from "@interfaces/screens/help-data.interface";
import { ProaUserHelp } from "@presenters/screens/help-proa.presenter";
import { MdPictureAsPdf, MdImage } from 'react-icons/md';
import { FaFileWord, FaFileExcel, FaFile } from 'react-icons/fa';
import styles from "./help.module.scss";

const UserHelp: FC<any> = () => {
  const [data, setData] = useState(null);

  const view: IUserHelp = {
    state: {
      data: data,
      setData: setData,
    },
  };
  const presenter = new ProaUserHelp(view);

  useEffect(() => {
    presenter.initialize();
  }, []);

  const fileIcon = (fileName: string): any => {
    let fileNameSplit = fileName.split('.');
    let fileExtention = fileNameSplit[fileNameSplit.length - 1];
    let htmlElement: any;

    switch (fileExtention) {
        case 'pdf':
            htmlElement = <MdPictureAsPdf className={styles.image} />;
            break;
        case 'doc':
        case 'docx':
            htmlElement = <FaFileWord className={styles.image} />;
            break;
        case 'xlsx':
        case 'xls':
            htmlElement = <FaFileExcel className={styles.image} />;
            break;
        case 'png':
        case 'jpg':
        case 'jpeg':
            htmlElement = <MdImage className={styles.image} />;
            break;
        default:
            htmlElement = <FaFile className={styles.image} />
            break;
    }
    return htmlElement;
}

  const renderItem = (item:any) => {    
    return (
      <Col>
        <a className={styles.itemList}        
          href={item.ServerRedirectedEmbedUri}
          target="_blank"
          id={"view_" + item.UniqueId}
          >
            <label>{fileIcon(item.File.Name)}</label>
            <p>{item.File.Name}</p>
        </a>
      </Col>
    )
  }

  const render = () => {
    return data != null ?
      <Container fluid={false} className={styles.helpContainer}>        
        <Row>
          <h2 style={{paddingBottom:"5px"}}>{presenter.currentLabels.get("titlePageHelp")}</h2>
          <List
            className={styles.listSearch}
            dataSource={data}
            height={360}
            itemRender={renderItem}
            searchExpr="File.Name"
            searchEnabled={true}
            searchMode={"contains"}
          />
        </Row>
      </Container>
      : <div></div>
  }

  return render();
};

export default UserHelp;
